export default __webpack_public_path__ + "static/media/heading_background.332a6031.mp4";